'use client'
import { clsx } from 'clsx'
import { AnimatePresence, domAnimation, LazyMotion, m as motion } from 'framer-motion'

import { FC } from 'react'

import BurgerWrapperComponent from '@/app/shared/components/burger-wrapper/burger-wrapper.component'
import SignUpLessonComponent from '@/app/shared/components/modals/sign-up-lesson/sign-up-lesson.component'
import { PhoneInfoComponent } from '@/app/shared/components/phone-info'
import { ITypeSite } from '@/app/shared/store/layout.store'
import useModal from '@/app/shared/store/modals.store'
import { ButtonComponent } from '@/app/shared/ui/button'
import { ContainerComponent } from '@/app/shared/ui/container'
import { LogoComponent } from '@/app/shared/ui/logo'
import { t } from '@/core/lib/locale/i18n'

// interface
interface IHeader {
  typeSite: ITypeSite | null
}

// component
const HeaderComponent: FC<Readonly<IHeader>> = ({ typeSite = 'offline' }) => {
  const open = useModal((state) => state.open)
  // const [isScrolled, setIsScrolled] = useState<boolean>(false)

  const handleOpenModalSignUp = () => {
    open({
      component: SignUpLessonComponent,
      props: {
        title: typeSite === 'offline' ? t.enter_to_free_lesson() : t.sign_up_text(),
      },
    })
  }

  // useEffect(() => {
  //   scroll((progress: number) => setIsScrolled(progress > 0))
  // }, [])

  // return
  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        <motion.header
          className={clsx('fixed top-0 z-40 w-full py-2', {
            'bg-secondary': typeSite === 'online',
            'bg-success': typeSite !== 'online',
          })}
          initial={{
            opacity: 0,
            y: -30,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            delay: 1,
            ease: 'easeInOut',
          }}
        >
          <ContainerComponent>
            <motion.div
              className={clsx(
                'relative flex w-full items-center before:absolute before:-left-[10px] before:-top-[10px] before:-z-[1] before:h-[calc(100%+20px)] before:w-[calc(100%+20px)] before:rounded-medium before:duration-500 before:transition-background',
                // {'before:bg-content1-200 before:bg-opacity-40 before:backdrop-blur': isScrolled,},
              )}
            >
              <div className={'flex w-full flex-col'}>
                <PhoneInfoComponent className={'tablet:hidden'} />

                <div className={'flex w-full items-center max-tablet:justify-between'}>
                  <LogoComponent className={'mr-1 laptop:mr-0'} typeSite={typeSite} />

                  <PhoneInfoComponent className={'ml-auto max-tablet:hidden'} />
                  <ButtonComponent
                    className={
                      'ml-auto hidden w-[173px] border-2 border-content1-200 bg-content1-200 px-1 data-[hover=true]:border-primary data-[present=true]:border-primary lg:ml-5 tablet:flex'
                    }
                    onClick={handleOpenModalSignUp}
                  >
                    <span className={'font-semibold uppercase'}>записатись</span>
                  </ButtonComponent>
                  <BurgerWrapperComponent className={'ml-auto extraMobile:ml-5'} />
                </div>
              </div>
            </motion.div>
            {/*<ButtonComponent*/}
            {/*  className={*/}
            {/*    'ml-5 flex h-10 w-[63px] flex-shrink-0 items-center justify-center bg-white p-0'*/}
            {/*  }*/}
            {/*>*/}
            {/*  <span className={'relative block h-[19px] w-[33px] border-b-2 border-t-2 border-blue'}>*/}
            {/*    <span className={'absolute top-1/2 block h-0.5 w-full -translate-y-1/2 bg-blue'}></span>*/}
            {/*  </span>*/}
            {/*</ButtonComponent>*/}
          </ContainerComponent>
        </motion.header>
      </AnimatePresence>
    </LazyMotion>
  )
}

export default HeaderComponent
